import { AfterViewInit, Component, Input } from '@angular/core';

import { GeneralStatusService } from '../../services/general-status.service';

// Functions history-alarms.chart.js
declare function initializeChartDataAlertHistory(history_options: any): void;
declare function updateChartDataAlertHistory(data: any): void;

@Component({
  selector: 'app-alarms-history-chart',
  standalone: true,
  imports: [],
  templateUrl: './alarms-history-chart.component.html',
  styleUrls: ['./alarms-history-chart.component.scss'],
})
export class AlarmsHistoryChartComponent implements AfterViewInit {
  @Input() installationIds?: string;

  history_options: any = {
    series: [
      {
        name: 'Warnings',
        type: 'area',
        data: [],
      },
      {
        name: 'Criticals',
        type: 'area',
        data: [],
      },
    ],
    chart: {
      type: 'line',
      height: '89rem',
      fontFamily: 'Nunito Sans,sans-serif',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: true,
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ['#ffc36d', '#ff5050'],
    stroke: {
      curve: 'smooth',
      lineCap: 'round',
      width: 2,
      colors: ['#ffc36d', '#ff5050'],
    },
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    fill: {
      type: 'solid',
      colors: ['#ffc36d', '#ff5050'],
      opacity: 0.1,
    },
    tooltip: {
      theme: 'dark',
      style: {
        fontSize: '13px',
        fontFamily: 'Nunito Sans,sans-serif',
      },
      colors: ['#ffc36d', '#ff5050'],
      x: {
        show: true,
      },
      y: {
        formatter: undefined,
      },
      marker: {
        show: true,
      },
      followCursor: true,
    },
    legend: {
      show: false,
    },
  };

  constructor(private service: GeneralStatusService) {}

  ngAfterViewInit(): void {
    initializeChartDataAlertHistory(this.history_options);
    this.updateChart();
    this.startHourlyUpdate();
  }

  updateChart() {
    const hours = 47;
    this.service
      .getHistoryAlarms(this.installationIds!, hours)
      .subscribe((res) => {
        updateChartDataAlertHistory(res);
      });
  }

  startHourlyUpdate() {
    let funcionEjecutada = false;

    setInterval(() => {
      const currentDate = new Date();
      const currentMinutes = currentDate.getMinutes();

      //Verifica si estamos en el minuto exacto
      if (currentMinutes === 0 && !funcionEjecutada) {
        funcionEjecutada = true;

        this.updateChart();
      }
      //Restablece la variable solo cuando no estamos en el minuto exacto
      else if (currentMinutes !== 0) {
        funcionEjecutada = false;
      }
    }, 3000);
  }
}
